<button type="button"
  class="dropzone-container"
  [class.drag-over]="isDragOver"
  [class.disabled]="disabled"
  [disabled]="disabled"
  aria-label="Drop files here or click to browse"
  (click)="onContainerClick()"
  (keydown)="onKeyDown($event)">

  <input type="file"
    #fileInput
    [accept]="getAcceptString()"
    [multiple]="multiple"
    [disabled]="disabled"
    (change)="onFileInputChange($event)"
    class="file-input" />

    <mat-icon class="upload-icon">cloud_upload</mat-icon>

    <span class="dropzone-text">
      @if (!isDragOver) {
        Drag &amp; drop files here or <span class="link-text">click to browse</span>
      }
      @if (isDragOver) {
        Release to upload files
      }
    </span>

    <span class="dropzone-hint">
      {{ hintText }} (max {{ formatFileSize(maxSizeBytes) }})
    </span>
  </button>
